import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const ClassDrive_fileReadSlice = createSlice({
  name: "ClassDrive_fileReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    ClassDrive_fileRead: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successClassDrive_fileRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureClassDrive_fileRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearClassDrive_fileRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  ClassDrive_fileRead,
  successClassDrive_fileRead,
  failureClassDrive_fileRead,
  clearClassDrive_fileRead,
} = ClassDrive_fileReadSlice.actions;

export default ClassDrive_fileReadSlice.reducer;
